import script from "./VisayasWaterParks.vue?vue&type=script&setup=true&lang=js"
export * from "./VisayasWaterParks.vue?vue&type=script&setup=true&lang=js"

import "./VisayasWaterParks.vue?vue&type=style&index=0&id=30158038&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30158038"]])

export default __exports__